<template>
  <v-row class="wish-list-section overview-container py-0">
    <v-col cols="12" md="12" class="text-center text-uppercase mt-3">
      <div class="heading-h3">Your Wish List</div>
    </v-col>
    <v-col v-for="wish of wishes" :key="wish.product_id" cols="12" md="4">
      <ProductPreview :key="wish.product_id" :id="wish.product_id" :name="wish.product.name" :image="wish.product.image" :points="wish.product.points" />
    </v-col>
  </v-row>
</template>

<script>
  import ProductPreview from "@/components/Products/Preview";

  export default {
    name: "WishListSection",

    computed: {
      user() {
        return this.$store.getters.userInfo;
      },
      wishes() {
        return this.$store.getters.filterWishesByKidId(this.user.id);
      },
    },

    components: { ProductPreview },
  };
</script>

<style lang="scss" scoped>
  .wish-list-section {
    background-color: #f8f8f8;
  }
</style>



// WEBPACK FOOTER //
// src/components/WishList/WishListSection.vue